/**
 * Throws an error if the condition is falsy. The provided message is used as the error message.
 * A function can be provided to lazily generate the message.
 *
 * @param {any} condition
 * @param {string | (() => string)} [message]
 * @returns {void}
 */
export function invariant(condition: any, message?: string | (() => string)): asserts condition {
	if (condition) {
		return;
	}
	const provided: string | undefined = typeof message === "function" ? message() : message;

	throw new Error(provided ?? "Invariant failed");
}
